import { IMAGES } from './images'

export const ABOUT_CONTENT = {
  title: 'About Us',
  tagline: 'Protecting What Matters Most',
  heroImage: IMAGES.about,
  intro: [
    'Aegis Professional Services is a specialty pest management provider serving industrial, commercial, agricultural, food processing, warehousing, logistics, and port-related operations throughout Texas. We deliver customized, science-based pest management solutions designed to protect products, facilities, brands, and supply chains from the field to the final consumer.',
    'Our approach goes beyond traditional pest control. We understand that modern businesses operate in highly regulated environments where food safety, audit readiness, compliance, and operational continuity are critical. That\'s why our programs are built around prevention, documentation, risk mitigation, and long-term protection.',
    'Whether safeguarding grain storage facilities, food processing plants, distribution centers, warehouses, manufacturing operations, retail environments, or port facilities, our team develops site-specific programs tailored to the unique challenges of each operation.',
  ],
  mission: {
    title: 'Our Mission',
    text: 'To protect our clients\' products, facilities, people, and reputations through innovative pest management solutions that support operational excellence, regulatory compliance, and business success.',
  },
  whatWeDo: {
    title: 'What We Do',
    intro: 'Aegis Professional Services provides integrated pest management programs designed for:',
    items: [
      'Agricultural Operations',
      'Grain Handling & Storage Facilities',
      'Food Processing Plants',
      'Warehouses & Distribution Centers',
      'Cold Storage Facilities',
      'Manufacturing Facilities',
      'Commercial Properties',
      'Transportation & Logistics Operations',
      'Ports of Entry & Marine Facilities',
      'Foreign Trade Zones',
    ],
    outro: 'Our services are designed to support every stage of the supply chain from harvest and processing to storage, transportation, export, and ultimately the consumer.',
  },
  whyChoose: {
    title: 'Why Clients Choose Aegis',
    items: [
      {
        title: 'Industry Expertise',
        text: 'Our team understands the unique pest pressures and compliance requirements associated with commercial and agricultural environments.',
      },
      {
        title: 'Compliance Driven',
        text: 'We help clients maintain readiness for audits, inspections, and regulatory requirements through detailed documentation and proactive pest management strategies.',
      },
      {
        title: 'Customized Solutions',
        text: 'No two facilities are the same. We develop programs specifically tailored to your operation, facility design, risk profile, and business objectives.',
      },
      {
        title: 'Responsive Support',
        text: 'We believe communication is critical. Our clients receive timely service, rapid response, and ongoing support from professionals committed to protecting their operations.',
      },
      {
        title: 'Long-Term Partnership',
        text: 'We focus on building lasting relationships by delivering measurable results and helping our clients reduce risk, improve compliance, and protect their brand.',
      },
    ],
  },
  commitment: {
    title: 'Our Commitment',
    text: 'At Aegis Professional Services, we are committed to delivering effective pest management solutions that support food safety, operational integrity, and customer confidence. Every service we provide is guided by professionalism, accountability, attention to detail, and a dedication to protecting what matters most.',
  },
}
